import { DocumentReference } from "firebase/firestore";

import { FirestoreOfflineDocument } from "@/core/modules/firestore/objects/FirestoreOfflineDocument";
import { PrescriptionDuration } from "./PrescriptionDuration";

import { EnumField, NumberWithDefaultField, StringField } from "@/core/fields";

export class Prescription extends FirestoreOfflineDocument {
  public name: string | undefined = undefined;
  public duration: PrescriptionDuration = PrescriptionDuration.Permanent;
  public order = 999;

  public constructor(firestoreData?: Record<string, unknown>, id?: string) {
    super(id);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData, id);
  }

  public fromFirestore(data: Record<string, unknown>, id?: string, firestoreRef?: DocumentReference): Prescription {
    super.fromFirestore(data, id, firestoreRef);

    this.name = StringField.fromFirestore(data.name);
    this.duration = EnumField.fromFirestore<PrescriptionDuration>(data.duration, Object.values(PrescriptionDuration), PrescriptionDuration.Permanent);
    this.order = NumberWithDefaultField.fromFirestore(data.order, 999);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.duration = EnumField.toFirestore<PrescriptionDuration>(this.duration, PrescriptionDuration.Permanent);
    firestoreData.order = NumberWithDefaultField.toFirestore(this.order, 999);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): Prescription {
    super.fromOfflineCache(data);

    this.name = StringField.fromOfflineCache(data.name);
    this.duration = EnumField.fromFirestore<PrescriptionDuration>(data.duration, Object.values(PrescriptionDuration), PrescriptionDuration.Permanent);
    this.order = NumberWithDefaultField.fromOfflineCache(data.order, 999);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.name = StringField.toOfflineCache(this.name);
    firestoreData.duration = EnumField.toOfflineCache<PrescriptionDuration>(this.duration, PrescriptionDuration.Permanent);
    firestoreData.order = NumberWithDefaultField.toOfflineCache(this.order, 999);

    return firestoreData;
  }
}
